import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TrainingResultEditorPage } from './training-result-editor';
import { Ionic2RatingModule } from 'ionic2-rating';


@NgModule({
  declarations: [
    TrainingResultEditorPage,
  ],
  imports: [
    IonicPageModule.forChild(TrainingResultEditorPage),
    Ionic2RatingModule,
  ],
})
export class TrainingResultEditorPageModule {}



// WEBPACK FOOTER //
// ./src/pages/training-result-editor/training-result-editor.module.ts